export default __webpack_public_path__ + "static/media/headerHorse.b9ed9347.jpg";